export default "__VITE_ASSET__DJ37wIvT__"